import { Column, Entity, JoinColumn, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn} from "typeorm"
import { OrderItem } from "./OrderItem"
import { XeroAddress } from "./XeroAddress"
import { Client } from "./Client"
import { User } from "./User"
import { DeliveryState } from "../../enumerations/delivery-state"
import { OrderState } from "../../interfaces"

@Entity()
export class Order {

	@PrimaryGeneratedColumn()
  id?: number
  
  @OneToMany(() => OrderItem, (item:OrderItem) => item.order)
  items?: OrderItem[]

  @ManyToOne(() => XeroAddress, (address) => address.owningOrders)
  address?: XeroAddress

  @ManyToOne(() => Client, (client) => client.orders)
  client?: Client

  @ManyToOne(() => User, (users) => users.orders)
  user?: User

  @Column({ nullable: true }) 
  purchaseOrder?: string

  @ManyToOne(() => User)
  operative?: User

  @Column('datetime', {nullable:true, default:null})
	created?: Date;

  @Column('datetime', {nullable:true, default:null})
	estimateDeliveryDate?: Date;

  @Column('datetime', {nullable:true, default:null})
	deliveryDate?: Date

  @Column({nullable:true, default:null})
	trackingNumber?: string

  @ManyToOne(() => User)
  @JoinColumn()
  deliveryProvider?: User

  @Column({ default: DeliveryState.Open }) 
  deliveryState?: DeliveryState

  @Column('text', {nullable:true, default:null})
	clientNotes?: string

  @Column('text', {nullable:true, default:null})
	operativesNotes?: string

  @Column({ default: OrderState.Draft })
	orderState?: OrderState

  @Column('text', {nullable:true, default:null})
	contact_telephone?: string

  @Column('text', {nullable:true, default:null})
	cancellationReason?: string
}